import { DateAdapter } from '@angular/material/core';
import { NavigatorService } from '../services/navigator.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TimestampFormatPipe } from '../commons/timestampFormatPipe';
import { GenericDetailComponent } from '../shared/GenericDetailComponent';
import { ResponseQueryByCriteria } from '../shared/dto/responseQueryByCriteria';
import { SoftwareService } from '../services/device-aziendali/software.service';
import { SoftwareDTO } from '../shared/dto/device-aziendali/software';
import { DeviceDTO } from '../shared/dto/device-aziendali/device';

@Component({
  selector: 'app-device',
  templateUrl: './softwareDetail.component.html',
  styleUrls: ['./softwareDetail.component.scss']
})

export class SoftwareDetailComponent extends GenericDetailComponent implements OnInit, OnDestroy {

  software: SoftwareDTO;
  listaTipologie: string[] = [];

  deviceTableParams = {
      dataSource: [],
      displayedColumns: ['codiceCespite', 'mac', 'tipoId', 'collaboratore', 'detail'], 
      pageNumber: 0,
      pageSize: 10,
      length: 0,
      sortDirection: 'ASC',
      sortField: 'id'
  };



  constructor(
    private softwareService: SoftwareService,
    activeRoute: ActivatedRoute,
    dialog: MatDialog,
    snackBar: MatSnackBar,
    timestampFormatPipe: TimestampFormatPipe,
    router: Router,
    navigatorService: NavigatorService,
    dateAdapter: DateAdapter<Date>) {
    super(
      navigatorService,
      dialog,
      router,
      dateAdapter,
      activeRoute,
      snackBar,
      timestampFormatPipe);
    this.form = new FormGroup({
      id:                   new FormControl({ value: '', disabled: true }),
      nome:                 new FormControl('', Validators.required),
      tipologia:            new FormControl('', Validators.required),
      descrizione:          new FormControl('', Validators.required),
      signInOutDescription: new FormControl('', Validators.required),
      modalitaAccesso:      new FormControl('', Validators.required),
      utilizzatori:         new FormControl('', Validators.required),
      trasferimentoDati:    new FormControl(false),   //boolean
      
      deleteDate: new FormControl({ value: '', disabled: true }),
      deleteUser: new FormControl({ value: '', disabled: true }),
      insertDate: new FormControl({ value: '', disabled: true }),
      insertUser: new FormControl({ value: '', disabled: true }),
      updateDate: new FormControl({ value: '', disabled: true }),
      updateUser: new FormControl({ value: '', disabled: true }),
      optLock:    new FormControl({ value: '', disabled: true }),
    });
  }

  ngOnInit() {
    this.software = new SoftwareDTO();
    this.software.id = Number(this.activeRoute.snapshot.paramMap.get("id"));
    if (this.software.id != null && this.software.id != 0) {
      this.softwareRead();
      this.loadLinkedDevices();
    } else {
      this.software = new SoftwareDTO();
    }

    this.tipologieList();

  }

  softwareSave() {
    if (this.software.id == null) {
      this.softwareCreate();
    } else {
      this.softwareUpdate();
    }
  }

  softwareCreate() {
    if (this.form.valid) {
      this.formToDto();
      this.softwareService.create(this.software).subscribe(
        (res: SoftwareDTO) => {
          this.snackBar.open("Salvataggio avvenuto con successo!", null, { duration: 3000 });
          this.software = res;
          this.dtoToForm();
          this.form.markAsPristine();
        }, (err: any) => {
          this.snackBar.open("Hai superato il limite di caratteri inseribili!", null, { duration: 3000 });
        }
      );
    }
  }

  softwareUpdate() {
    if (this.form.valid && this.form.dirty) {
      this.confirm("Sei sicuro di voler sovrascrivere la tipologia?").subscribe(result => {
        if (result) {
          this.formToDto();
          this.softwareService.update(this.software).subscribe(
            (res) => {
              this.snackBar.open("Salvataggio avvenuto con successo!", null, { duration: 3000 });
              this.softwareRead();
              this.form.markAsPristine();
            }, (err: any) => {
              this.snackBar.open("Hai superato il limite di caratteri inseribili!", null, { duration: 3000 });
            }
          );
        }
      });
    }
  }

  softwareDelete() {
    this.confirm("Sei sicuro di voler cancellare questo tipo?").subscribe(result => {
      if (result) {
        this.formToDto();
        this.softwareService.delete(this.software.id).subscribe(
          (res) => {
            this.snackBar.open("Cancellazione avvenuta con successo!", null, { duration: 3000 });
            this.router.navigate(["/software"]);
          }
        );
      }
    });
  }

  softwareRead() {
    this.softwareService.read(this.software.id).subscribe(
      (res: SoftwareDTO) => {
        this.software = res;
        this.software.id = res.id;
        this.dtoToForm();
      }
    );
  }



  private formToDto(): void {
    this.software.id                    = this.form.get("id").value;
    this.software.nome                  = this.form.get("nome").value;
    this.software.tipologia             = this.form.get("tipologia").value;
    this.software.descrizione           = this.form.get("descrizione").value;
    this.software.signInOutDescription  = this.form.get("signInOutDescription").value;
    this.software.modalitaAccesso       = this.form.get("modalitaAccesso").value;
    this.software.utilizzatori          = this.form.get("utilizzatori").value;
    this.software.trasferimentoDati     = this.form.get("trasferimentoDati").value;
  }

  private dtoToForm(): void {
    this.form.get("id").setValue(this.software.id);
    this.form.get("nome").setValue(this.software.nome);
    this.form.get("tipologia").setValue(this.software.tipologia);
    this.form.get("descrizione").setValue(this.software.descrizione);
    this.form.get("signInOutDescription").setValue(this.software.signInOutDescription);
    this.form.get("modalitaAccesso").setValue(this.software.modalitaAccesso);
    this.form.get("utilizzatori").setValue(this.software.utilizzatori);
    this.form.get("trasferimentoDati").setValue(this.software.trasferimentoDati);
    this.form.get("deleteDate").setValue(this.software.deleteDate);
    this.form.get("deleteUser").setValue(this.software.deleteUser);
    this.form.get("insertDate").setValue(this.timestampFormatPipe.transform(this.software.insertDate));
    this.form.get("insertUser").setValue(this.software.insertUser);
    this.form.get("updateDate").setValue(this.timestampFormatPipe.transform(this.software.updateDate));
    this.form.get("updateUser").setValue(this.software.updateUser);
    this.form.get("optLock").setValue(this.software.optLock);
    this.form.markAsPristine();
  }


// --- NUOVI METODI PER LA TABELLA ---

  loadLinkedDevices() {
      // Chiamiamo il tuo metodo rinominato
      this.softwareService.softwareDeviceList(
        this.deviceTableParams.pageNumber,
        this.deviceTableParams.pageSize,
        this.deviceTableParams.sortDirection,
        this.deviceTableParams.sortField, 
        '',                                   // FILTRO
        this.software.id
      ).subscribe((res: ResponseQueryByCriteria<DeviceDTO>) => {
          this.deviceTableParams.dataSource = res.content;
          this.deviceTableParams.length = res.totalElements;
      });
  }

  setDevicePaginator(event: any) {
      this.deviceTableParams.pageNumber = event.pageIndex;
      this.deviceTableParams.pageSize = event.pageSize;
      this.loadLinkedDevices();
  }


  ngOnDestroy(): void {
  }

  tipologieList(): void {
    this.softwareService.getTipologia().subscribe(
      (tipi) => {
        this.listaTipologie = tipi;
      },
      (err) => {
        console.error("Impossibile caricare la lista delle tipologie", err);
      }
    );
  }

}